import React from 'react';
import { Button } from '@mui/material';
import { Chip } from 'components/Form';
import { Close } from '@mui/icons-material';
import { AdvancedButtonStyles } from './Style';

/**
 * כפתור להצגה והסתרה של אזור הסינון המתקדם (Advanced Filters).
 * מציג אינדיקציה (Badge/Chip) למספר הפילטרים הפעילים ומאפשר את איפוסם.
 * * @param {Object} props
 * @param {number} props.advancedFiltersCount - מספר הפילטרים המתקדמים שפעילים כרגע
 * @param {Function} props.removeAdvancedFilters - פונקציה לאיפוס/ניקוי כל הפילטרים המתקדמים
 * @param {boolean} props.isExpanded - האם אזור הסינון המתקדם פתוח כרגע
 * @param {Function} props.setIsExpanded - פונקציה לשינוי מצב הפתיחה/סגירה של אזור הסינון
 */
const AdvancedBtn = (props) => {
    const { advancedFiltersCount, removeAdvancedFilters, isExpanded, setIsExpanded } = props;

    return (
        <AdvancedButtonStyles  {...props} onClick={() => setIsExpanded(!isExpanded)}>
            <i className="fa-regular fa-filter"></i>
            {"סינון מתקדם"}

            {advancedFiltersCount > 0 && (
                <Chip color="white">
                    ({advancedFiltersCount})
                    <Close color="dark" fontSize="small" onClick={removeAdvancedFilters} />
                </Chip>
            )}

            {isExpanded ? (
                <i className="fa-solid fa-chevron-up"></i>
            ) : (
                <i className="fa-solid fa-chevron-down"></i>
            )}
        </AdvancedButtonStyles>
    );
};

export default AdvancedBtn;